module.exports = __webpack_public_path__ + "static/media/achieve4.cdc783ff.PNG";